export const MSG_BACK_LINK = 'Back';
export const MSG_OPEN_IN_NEW_WINDOW = 'open in new window';
export const MSG_FULL_SCREEN_VIEW = 'full screen view';
export const MSG_VIDEO_PLAYER_CURRENT_CHAPTER_LABEL = 'Playing';
export const MSG_VIDEO_PLAYER_NEXT_CHAPTER_LABEL = 'Next';